<div class="iq-feature10">
  <div class="left">
    <ng-content select="[cardMedia]"></ng-content>
  </div>
  <div class="right">
    <ng-content select="[cardBody]"></ng-content>
  </div>
</div>
